var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "home-banner" }, [
    _c("div", { staticClass: "home-banner__visual" }, [
      _vm.backgroundImage
        ? _c("img", {
            staticClass: "home-banner__image",
            attrs: { src: _vm.backgroundImage, alt: _vm.title },
          })
        : _c("div", { staticClass: "home-banner__placeholder" }, [
            _c("div", { staticClass: "home-banner__placeholder-logo" }, [
              _vm._v("VIXIO"),
            ]),
          ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "home-banner__content" }, [
      _vm.label
        ? _c("span", { staticClass: "home-banner__label" }, [
            _vm._v(_vm._s(_vm.label)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("h2", { staticClass: "home-banner__title" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _vm.subtitle
        ? _c("p", { staticClass: "home-banner__subtitle" }, [
            _vm._v(_vm._s(_vm.subtitle)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.ctaText
        ? _c(
            "div",
            { staticClass: "home-banner__cta-wrap" },
            [
              _vm.isInternalLink
                ? _c(
                    "nuxt-link",
                    {
                      staticClass: "home-banner__cta",
                      attrs: { to: _vm.ctaUrl },
                    },
                    [_vm._v("\n        " + _vm._s(_vm.ctaText) + "\n      ")]
                  )
                : _c(
                    "a",
                    {
                      staticClass: "home-banner__cta",
                      attrs: {
                        href: _vm.ctaUrl,
                        target: "_blank",
                        rel: "noopener",
                      },
                    },
                    [_vm._v("\n        " + _vm._s(_vm.ctaText) + "\n      ")]
                  ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.eventDate
        ? _c("span", { staticClass: "home-banner__date" }, [
            _vm._v(_vm._s(_vm.eventDate)),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }